import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';
import { Container, ReactSelect } from './styles'

const CustomStyle = {
  option: () => ({
    borderBottom: '1px dotted pink',
    color: 'red',
    padding: 20
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    width: 200,
  }),
  singleValue: () => {
    const opacity = 1;
    const transition = 'opacity 300ms';

    return { opacity, transition };
  }
}

class AxlReactSelect extends React.Component {
  static defaultProps = {
    placeholder: 'Select...',
    isMulti: false,
    closeMenuOnSelect: true,
    theme: this.topBarTheme
  };

  state = {
    selectedOption: null,
  };

  handleChange = (selectedOption) => {
    this.props.onChange(selectedOption);
    this.setState({ selectedOption });
  };

  render() {
    const { selectedOption } = this.state;
    const { placeholder, isMulti, options, closeMenuOnSelect, theme, fluid, value, maxMenuHeight } = this.props;

    return (
      <Container className={fluid ? 'fluid' : ''}>
        {(theme && !theme.topBarTheme) ? <ReactSelect
          isMulti={isMulti}
          value={value || selectedOption}
          closeMenuOnSelect={closeMenuOnSelect}
          onChange={this.handleChange}
          options={options}
          placeholder={placeholder}
          theme={theme}
        /> : <Select
          isMulti={isMulti}
          value={value || selectedOption}
          defaultValue={value}
          closeMenuOnSelect={closeMenuOnSelect}
          onChange={this.handleChange}
          options={options}
          placeholder={placeholder}
          theme={theme}
          maxMenuHeight={maxMenuHeight}
        />}
      </Container>
    );


  }

  static topBarTheme = (theme) => ({
    ...theme,
    borderRadius: 5,
    minHeight: 35,
    height: 35,
    border: 'none',
    colors: {
      ...theme.colors,
      text: '#cfcfcf',
      primary25: 'transparent',
      primary: '#cfcfcf'
    }
  });

  static submitOrderTheme = (theme) => ({
    ...theme,
    borderRadius: 0,
    colors: {
      ...theme.colors,
      text: 'rgb(236, 236, 236)',
      primary25: 'transparent',
      primary: 'rgb(236, 236, 236)',
      neutral10: 'rgb(236, 236, 236)',
      neutral20: 'rgb(236, 236, 236)',
      neutral30: 'rgb(236, 236, 236)'
    },
    spacing: {
      ...theme.spacing,
      controlHeight: 45,
    }
  });
}

AxlReactSelect.propTypes = {
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  onChange: PropTypes.func,
  theme: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  }))
};

export default AxlReactSelect;
